import React, { useState, useEffect } from 'react';
import { hoyISO } from '../utils/fechaHoy';

const API = 'https://solicitudes.hipotecavive.cloud/api';

const NOMBRES_ARCHIVO = {
  Afirme: {
    'anexo-a':           'Anexo A Afirme',
    'buro-titular':      'Formato Buro Afirme Titular',
    'buro-coacreditado': 'Formato Buro Afirme Coacreditado',
    'cotejo':            'Cotejo Expediente Afirme',
    'solicitud':         'Solicitud Credito Afirme',
  },
  Banorte: {
    'anexo-f':           'Anexo F Banorte',
    'buro-autorizacion': 'Formato Buro Banorte',
    'cotejo':            'Exp a Evaluacion Banorte',
    'solicitud':         'Solicitud Credito Banorte',
    'seguros-firma':     'Seguros Firma Banorte',
  },
  Santander: {
    'anexo-b':                   'Anexo B Santander',
    'buro-fisicas-titular':      'Buro PFisicas titular Santander',
    'buro-fisicas-coacreditado': 'Buro PFisicas coacreditado Santander',
    'buro-morales-titular':      'Buro PMorales titular Santander',
    'buro-morales-coacreditado': 'Buro PMorales coacreditado Santander',
    'solicitud':                 'Solicitud Credito Santander',
    'cuestionario-cualitativo-titular':      'Cuestionario Cualitativo Santander Titular',
    'cuestionario-cualitativo-coacreditado': 'Cuestionario Cualitativo Santander Coacreditado',
  },
  Banregio: {
    'aviso-privacidad-coac': 'Aviso Privacidad Coacreditado Banregio',
    'buro-titular':          'Formato Buro Titular Banregio',
    'buro-coacreditado':     'Formato Buro Coacreditado Banregio',
    'carta-autorizacion':    'Carta Autorizacion Tramite Banregio',
    'solicitud':             'Solicitud Credito Banregio',
  },
  Scotiabank: {
    'anexo-b':   'Anexo B Scotiabank',
    'solicitud': 'Solicitud Credito Scotiabank',
  },
  Banamex: {
    'carta_seguros_titular':      'Carta Seguros Titular Banamex',
    'carta_seguros_coacreditado': 'Carta Seguros Coacreditado Banamex',
    'solicitud':                  'Solicitud Credito Banamex',
  },
  HSBC: {
    'solicitud':                  'Solicitud Credito HSBC',
    'carta-seleccion-productos':  'Carta Seleccion Productos HSBC',
    'seguros-coacreditado':       'Formato Seguros Coacreditado HSBC',
  },
  General: {
    'autorizacion-puntacatoche': 'Autorizacion Puntacatache',
  },
};

const MASTER_PUNTACATACHE = 'Puntacatache Iberica, S. de R.L. de C.V.';

function Impresion() {
  const [prospectos, setProspectos] = useState([]);
  const [prospectoSeleccionado, setProspectoSeleccionado] = useState(null);
  const [formatosPorBanco, setFormatosPorBanco] = useState([]); // [{banco, formatos:[]}]
  const [generando, setGenerando] = useState(null);
  const [bancosAbiertos, setBancosAbiertos] = useState({});
  const [fechaFormatos, setFechaFormatos] = useState(() => hoyISO());
  const [filtroNombre, setFiltroNombre] = useState('');

  useEffect(() => {
    fetch(`${API}/impresion/prospectos`)
      .then(r => r.json())
      .then(data => setProspectos(data))
      .catch(err => console.error('Error cargando prospectos:', err));
  }, []);

  // Cargar formatos de todos los bancos disponibles del prospecto
  useEffect(() => {
    if (!prospectoSeleccionado) {
      setFormatosPorBanco([]);
      return;
    }
    const bancos = prospectoSeleccionado.bancos || [];
    const tieneGeneral = (prospectoSeleccionado.banorte_master || '').includes(MASTER_PUNTACATACHE);
    const bancosAConsultar = tieneGeneral ? [...bancos, 'General'] : bancos;
    if (bancosAConsultar.length === 0) {
      setFormatosPorBanco([]);
      return;
    }
    Promise.all(
      bancosAConsultar.map(banco =>
        fetch(`${API}/impresion/formatos/${banco.toLowerCase()}?prospecto_id=${prospectoSeleccionado.id}`)
          .then(r => r.ok ? r.json() : [])
          .then(formatos => ({ banco, formatos: Array.isArray(formatos) ? formatos : [] }))
          .catch(() => ({ banco, formatos: [] }))
      )
    ).then(resultados => {
      const filtrados = resultados.filter(r => r.formatos.length > 0);
      setFormatosPorBanco(filtrados);
      // Todos los bancos cerrados por defecto al cargar
      setBancosAbiertos({});
    });
  }, [prospectoSeleccionado]);

  const seleccionarProspecto = (e) => {
    const id = parseInt(e.target.value);
    const prospecto = prospectos.find(p => p.id === id);
    setProspectoSeleccionado(prospecto || null);
  };

  const generarPDF = async (banco, formatoId) => {
    if (!prospectoSeleccionado) return;
    const key = `${banco}-${formatoId}`;
    setGenerando(key);
    try {
      const url = `${API}/impresion/${banco.toLowerCase()}/${formatoId}/${prospectoSeleccionado.id}?fecha=${fechaFormatos}`;
      const response = await fetch(url);
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error generando PDF');
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      const nombreArchivo = NOMBRES_ARCHIVO[banco]?.[formatoId] || `${formatoId}-${banco}`;
      a.download = `${nombreArchivo}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      alert('Error: ' + error.message);
    } finally {
      setGenerando(null);
    }
  };

  const CONECTORES = new Set(['de', 'del', 'la', 'las', 'los', 'y']);
  const aCapitalizado = (str) =>
    (str || '')
      .toLowerCase()
      .split(' ')
      .filter(Boolean)
      .map((palabra, i) => (i > 0 && CONECTORES.has(palabra)) ? palabra : palabra.charAt(0).toUpperCase() + palabra.slice(1))
      .join(' ');

  const getNombreCompleto = (p) =>
    aCapitalizado(`${p.nombres || ''} ${p.apellido_paterno || ''} ${p.apellido_materno || ''}`.trim()) || 'Sin nombre';

  const getFolioDisplay = (p) =>
    p.folio ? String(p.folio).replace(/^0+(?=\d)/, '') : p.id;

  const prospectosOrdenados = [...prospectos].sort((a, b) =>
    parseInt(b.folio || 0, 10) - parseInt(a.folio || 0, 10)
  );

  const filtroNombreNormalizado = filtroNombre.trim().toLowerCase();
  const resultadosFiltrados = filtroNombreNormalizado
    ? prospectosOrdenados.filter(p =>
        getNombreCompleto(p).toLowerCase().includes(filtroNombreNormalizado) ||
        String(p.folio || p.id).toLowerCase().includes(filtroNombreNormalizado) ||
        String(getFolioDisplay(p)).toLowerCase().includes(filtroNombreNormalizado)
      )
    : [];

  const seleccionarDesdeFiltro = (p) => {
    setProspectoSeleccionado(p);
    setFiltroNombre('');
  };

  return (
    <div>
      <h2 style={{ marginBottom: 20 }}>Impresión de Formatos</h2>

      {/* Selector de Prospecto */}
      <div style={{ marginBottom: 30, padding: 20, backgroundColor: '#f8f9fa', borderRadius: 8 }}>
        <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 300px' }}>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 'bold' }}>
              Seleccionar Cliente:
            </label>
            <select
              onChange={seleccionarProspecto}
              value={prospectoSeleccionado?.id || ''}
              style={{
                width: '100%',
                maxWidth: 500,
                padding: '10px 12px',
                fontSize: 14,
                border: '1px solid #ccc',
                borderRadius: 4
              }}
            >
              <option value="">-- Seleccione un cliente --</option>
              {prospectosOrdenados.map(p => (
                <option key={p.id} value={p.id}>
                  {getFolioDisplay(p)} - {getNombreCompleto(p)}
                </option>
              ))}
            </select>
          </div>

          <div style={{ flex: '1 1 300px' }}>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 'bold' }}>
              Buscar por nombre:
            </label>
            <input
              type="text"
              value={filtroNombre}
              onChange={e => setFiltroNombre(e.target.value)}
              placeholder="Escriba el nombre del cliente..."
              style={{
                width: '100%',
                maxWidth: 500,
                padding: '10px 12px',
                fontSize: 14,
                border: '1px solid #ccc',
                borderRadius: 4
              }}
            />
          </div>
        </div>
      </div>

      {/* Info del cliente seleccionado */}
      {prospectoSeleccionado && (
        <div style={{ marginBottom: 30, padding: 20, backgroundColor: '#e7f3ff', borderRadius: 8, border: '1px solid #b3d7ff' }}>
          <h3 style={{ margin: '0 0 10px 0', color: '#1a3a6e' }}>
            {getNombreCompleto(prospectoSeleccionado)}
          </h3>
          {(prospectoSeleccionado.bancos || []).length > 0 ? (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {prospectoSeleccionado.bancos.map(b => (
                <span key={b} style={{
                  backgroundColor: '#1a3a6e', color: 'white',
                  padding: '3px 10px', borderRadius: 4, fontSize: 13
                }}>
                  {b}
                </span>
              ))}
            </div>
          ) : (
            <p style={{ margin: 0, color: '#856404' }}>Sin información de banco capturada.</p>
          )}
        </div>
      )}

      {/* Fecha de los formatos */}
      <div style={{ marginBottom: 24, padding: '14px 20px', backgroundColor: '#fff8e6', borderRadius: 8, border: '1px solid #f0c040', display: 'flex', alignItems: 'center', gap: 14 }}>
        <label style={{ fontWeight: 'bold', fontSize: 14, whiteSpace: 'nowrap' }}>
          Fecha a imprimir en los formatos:
        </label>
        <input
          type="date"
          value={fechaFormatos}
          onChange={e => setFechaFormatos(e.target.value)}
          style={{ padding: '7px 12px', fontSize: 14, border: '1px solid #ccc', borderRadius: 4 }}
        />
      </div>

      {/* Resultados del filtro por nombre */}
      {filtroNombreNormalizado && (
        <div style={{ marginBottom: 30, border: '1px solid #ddd', borderRadius: 8, overflow: 'hidden' }}>
          {resultadosFiltrados.length > 0 ? (
            <div style={{ display: 'grid', gap: 1, backgroundColor: '#f0f0f0' }}>
              {resultadosFiltrados.map(p => (
                <div
                  key={p.id}
                  onClick={() => seleccionarDesdeFiltro(p)}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px 18px',
                    backgroundColor: prospectoSeleccionado?.id === p.id ? '#e7f3ff' : 'white',
                    cursor: 'pointer',
                  }}
                >
                  <span style={{ fontSize: 14 }}>
                    <strong>{getFolioDisplay(p)}</strong> - {getNombreCompleto(p)}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ padding: '14px 18px', color: '#666', fontSize: 14 }}>
              No se encontraron clientes con ese nombre.
            </div>
          )}
        </div>
      )}

      {/* Formatos agrupados por banco — acordeón */}
      {prospectoSeleccionado && formatosPorBanco.length > 0 && (
        <div style={{ display: 'grid', gap: 12 }}>
          {formatosPorBanco.map(({ banco, formatos }) => {
            const abierto = !!bancosAbiertos[banco];
            return (
              <div key={banco} style={{ border: '1px solid #ddd', borderRadius: 8, overflow: 'hidden' }}>
                {/* Cabecera clickeable */}
                <div
                  onClick={() => setBancosAbiertos(prev => ({ ...prev, [banco]: !prev[banco] }))}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '14px 18px',
                    backgroundColor: '#1a3a6e',
                    color: 'white',
                    cursor: 'pointer',
                    userSelect: 'none',
                  }}
                >
                  <span style={{ fontWeight: 'bold', fontSize: 15 }}>
                    Formatos — {banco}
                  </span>
                  <span style={{ fontSize: 18 }}>{abierto ? '▲' : '▼'}</span>
                </div>

                {/* Contenido colapsable */}
                {abierto && (
                  <div style={{ display: 'grid', gap: 1, backgroundColor: '#f0f0f0' }}>
                    {formatos.map(formato => {
                      const key = `${banco}-${formato.id}`;
                      return (
                        <div
                          key={formato.id}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 18px',
                            backgroundColor: 'white',
                          }}
                        >
                          <div>
                            <strong style={{ fontSize: 14 }}>{formato.nombre}</strong>
                            {formato.descripcion && (
                              <p style={{ margin: '3px 0 0', color: '#666', fontSize: 12 }}>
                                {formato.descripcion}
                              </p>
                            )}
                          </div>
                          <button
                            onClick={() => generarPDF(banco, formato.id)}
                            disabled={generando === key}
                            style={{
                              padding: '8px 18px',
                              backgroundColor: generando === key ? '#ccc' : '#f97316',
                              color: 'white',
                              border: 'none',
                              borderRadius: 6,
                              cursor: generando === key ? 'not-allowed' : 'pointer',
                              fontWeight: 'bold',
                              minWidth: 130,
                              fontSize: 13
                            }}
                          >
                            {generando === key ? 'Generando...' : '📄 Generar PDF'}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Sin bancos capturados */}
      {prospectoSeleccionado && (prospectoSeleccionado.bancos || []).length === 0 && (
        <div style={{ padding: 20, backgroundColor: '#fff3cd', borderRadius: 8, border: '1px solid #ffc107' }}>
          <p style={{ margin: 0, color: '#856404' }}>
            ⚠️ Este cliente no tiene información de ningún banco capturada.
          </p>
        </div>
      )}
    </div>
  );
}

export default Impresion;
